import { useEffect, useRef, useState } from "react";
import { Box, Paper, Typography } from "../../../components";
import palette from "../../../styles/dark-theme/palette";
import { messageSlideUp, subtleFloat } from "../constantes.login";

const ChatComponent = () => {
  const [visibleMessages, setVisibleMessages] = useState([]);
  const [isTitleVisible, setIsTitleVisible] = useState(false);
  const scrollRef = useRef(null);
  const timeoutsRef = useRef([]);

  const initialMessages = [
    { text: "Oi 👋 eu sou o SIAF Evolution", side: "left" },
    { text: "Seu ERP simples, rápido e completo", side: "left" },
    { text: "Vou te ajudar a organizar sua empresa 💼", side: "left" },
    { text: "Sério? O que você faz?", side: "right" },
    { text: "Começamos pelo básico:", side: "left" },
    { text: "📋 Cadastro Simplificado de clientes e produtos", side: "left" },
    { text: "E o financeiro?", side: "right" },
    { text: "💰 Controle de Caixa em tempo real", side: "left" },
    { text: "📊 Gestão Financeira completa", side: "left" },
    { text: "📈 Relatórios e análise de resultados", side: "left" },
    { text: "Emite nota fiscal também?", side: "right" },
    { text: "Claro 😎", side: "left" },
    { text: "🧾 Emissão de Notas Fiscais integrada", side: "left" },
    { text: "E o estoque?", side: "right" },
    { text: "📦 Controle de Estoque automático", side: "left" },
    { text: "Sem planilhas, sem dor de cabeça 🙌", side: "left" },
    { text: "Nossa… parece completo 😮", side: "right" },
    { text: "E o melhor:", side: "left" },
    { text: "Tudo em um só lugar 🚀", side: "left" },
  ];

  const startChat = () => {
    clearChat();
    setIsTitleVisible(true);
    initialMessages.forEach((msg, index) => {
      const timeout = setTimeout(() => {
        setVisibleMessages((prev) => [...prev, msg]);
      }, (index + 1) * 1200);
      timeoutsRef.current.push(timeout);
    });
  };

  const clearChat = () => {
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];
    setVisibleMessages([]);
    setIsTitleVisible(false);
  };

  useEffect(() => {
    startChat();
    return () => timeoutsRef.current.forEach(clearTimeout);
  }, []);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [visibleMessages, isTitleVisible]);

  return (
    <Box
      className="me-5 rounded-5 info-tab"
      sx={{
        background: palette.primary.main,
        position: "relative",
        overflow: "hidden",
        width: "60%",
        display: "flex",
        flexDirection: "column",
        perspective: "1000px",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: 400,
          height: 400,
          filter: "blur(120px)",
          top: -80,
          right: -80,
          opacity: 0.5,
          zIndex: 0,
        }}
      />
      <Box
        ref={scrollRef}
        className="d-flex flex-column"
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          zIndex: 1,
          px: 6,
          pb: 6,
          "&::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
          maskImage: "linear-gradient(to bottom, transparent 0%, black 60%)",
          WebkitMaskImage:
            "linear-gradient(to bottom, transparent 0%, black 60%)",
        }}
      >
        <Box
          sx={{
            minHeight: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            gap: 2,
            pt: "250px",
          }}
        >
          {isTitleVisible && (
            <Box
              sx={{
                animation: `${messageSlideUp} 1s cubic-bezier(0.22, 1, 0.36, 1) forwards`,
                opacity: 0,
                mb: 2,
              }}
            >
              <Typography variant="h4" fontWeight="bold" color="white">
                <span className="fw-bolder">ERP</span> inteligente para sua
                empresa
              </Typography>
            </Box>
          )}
          {visibleMessages.map((msg, i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                justifyContent: msg.side === "left" ? "flex-start" : "flex-end",
                animation: `${messageSlideUp} 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards`,
                opacity: 0,
              }}
            >
              <Paper
                sx={{
                  boxShadow: "0px 0px 56px rgba(0, 0, 0, 0.1) !important",
                  p: 1.5,
                  px: 2,
                  maxWidth: "70%",
                  borderRadius: 3,
                  bgcolor: msg.side === "left" ? "white" : "#1a3358",
                  color: msg.side === "left" ? "#1a3358" : "white",
                  animation: `${subtleFloat} 3s ease-in-out infinite`,
                  transition: "transform 0.3s ease",
                  animationDelay: `${i * 0.2}s`,
                  fontWeight: 300,
                }}
              >
                {msg.text}
              </Paper>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ChatComponent;
